import React from "react";
import { motion } from "framer-motion";

/**
 * SectionReveal — wraps children with a subtle fade + translate reveal
 * triggered on scroll via framer-motion's `whileInView`.
 * Non-bouncy easing per design spec.
 */
export default function SectionReveal({
  children,
  delay = 0,
  className = "",
  as = "div",
  yOffset = 24,
}) {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y: yOffset }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.6, delay, ease: [0.22, 0.61, 0.36, 1] }}
    >
      {children}
    </MotionTag>
  );
}
